<script setup lang="ts">
import ReportState, { ReportSection } from "@/stores/report/ReportState";
import { computed } from "vue";
import { HEADER_HEIGHT, TABS_HEIGHT } from "./constants";

const tabs = [
  {
    id: ReportSection.GENERAL,
    label: "report:navigation.general",
    icon: "bi-info-circle",
  },
  {
    id: ReportSection.PHOTOS,
    label: "report:navigation.photos",
    icon: "bi-images",
  },
  {
    id: ReportSection.FINDINGS,
    label: "report:navigation.findings",
    icon: "bi-list-check",
  },
  {
    id: ReportSection.OVERVIEWS,
    label: "report:navigation.overviews",
    icon: "bi-grid-3x3",
  },
  {
    id: ReportSection.CONCLUSIONS,
    label: "report:navigation.conclusions",
    icon: "bi-file-text",
  },
];

const activeTab = computed(() => ReportState.activeSection);

const setActiveTab = (section: ReportSection) => {
  ReportState.setActiveSection(section);
};
</script>

<template>
  <div
    class="report-tabs bg-white border-bottom d-flex align-items-end px-4 p-0"
    :style="`height: ${TABS_HEIGHT}px; top: ${HEADER_HEIGHT}px; z-index: 1`"
  >
    <div class="d-flex gap-1">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-item px-4 py-2 border-0 bg-transparent position-relative d-flex align-items-center gap-2"
        :class="{ active: activeTab === tab.id }"
        @click="setActiveTab(tab.id)"
      >
        <el-icon size="16"><i :class="tab.icon"></i></el-icon>
        <span class="tab-label">{{ $t(tab.label) }}</span>
        <div v-if="activeTab === tab.id" class="tab-indicator"></div>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/variables.scss";

.report-tabs {
  position: fixed;
  left: 0;
  right: 0;
}

.tab-item {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.2s;
  border-radius: 4px 4px 0 0;

  &:hover {
    color: $dark;
    background-color: rgba(0, 0, 0, 0.04);
  }

  &.active {
    color: $primary;
  }
}

.tab-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: $primary;
  border-radius: 3px 3px 0 0;
}
</style>
